import toast from 'react-hot-toast';
import { createInventory } from '../../../backend-services/inventory';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Inventory, InventoryItem, Variation, VariationItem } from '../../../@types/inventory';
import { Button } from '../../common';
import { InventoryForm } from './InventoryForm';
import { SidebarDrawer } from '../../common';
import { useInventoryStore } from '../../../state/useInventoryStore';
import VariationList from '../Variations/VariationList';
import PageLoader from '../../../components/common/PageLoader';
import VariationForm from '../Variations/VariationForm';
import { convertToFloat } from '../../../utils/convertToFloat';
import { ValidateVariation, validateCreateInventory } from '../../../modules/inventory/inventory';

const InventoryPage = () => {
  const navigate = useNavigate();
  const [error, setError] = React.useState({
    name: '',
    quantity: '',
    rate: '',
    costPrice: '',
    description: '',
  });
  const [errorMessage, setErrorMessage] = React.useState('');
  const [variationList, setVariationList] = useState<VariationItem[]>([]);
  const [inventories, setInventories] = useState<InventoryItem>({
    name: '',
    rate: '',
    costPrice: '',
    quantity: '',
    description: '',
    variations: [],
  });

  const handleCreateInventory = async () => {
    const newRate = convertToFloat(inventories.rate);
    const newQuantity = convertToFloat(inventories.quantity);
    const newCostPrice = convertToFloat(inventories.costPrice);

    const newVariationList = variationList.map((item) => ({
      ...item,
      price: convertToFloat(item.price),
      costPrice: convertToFloat(item.costPrice),
      quantity: convertToFloat(item.quantity),
    }));

    const { hasErrors, errors } = validateCreateInventory({
      rate: newRate,
      quantity: newQuantity,
      costPrice: newCostPrice,
      name: inventories.name,
    });

    const variationErrorMsg = ValidateVariation(newVariationList)
    console.log(variationErrorMsg)

    if (hasErrors) {
      setError(errors)
      return
    } 
    else {
      try {
        setIsLoading(true);
        const newInventory = {
          ...inventories,
          rate: newRate,
          costPrice: newCostPrice,
          quantity: newQuantity,
          variations: newVariationList,
        };
        const response = await createInventory(newInventory);
        setIsLoading(false);
        setInventories({
          name: '',
          rate: '',
          quantity: '',
          costPrice: '',
          description: '',
          variations: [],
        });
        toast.success('New Inventory Added Successfully!');
        navigate('/inventories');
      } catch (error: any) {
        if (error.message === 'Inventory already exists') {
          setErrorMessage(error.message);
        } else {
          setErrorMessage('Unable to create inventory: ' + error.message);
        }
        setIsLoading(false);
      }
    }
  };

  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [isFormSideBarOpen, setIsFormSideBarOpen] = useState<boolean>(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [variationState, setVariationState] = useState([])

  const { fetchVariations } = useInventoryStore((state) => ({
    fetchVariations: state.fetchVariation,
  }));

  const { variations, Loading, createVariation } = useInventoryStore((state) => ({
    variations: state.variations,
    Loading: state.isLoading,
    createVariation: state.createVariation
  }));

  useEffect(() => {
    fetchVariations && fetchVariations() ;
    setVariationState(variations)
    setShowCreateForm(false)
  },[fetchVariations, variationState]);


  const handleCancel = () => {
    navigate('/inventories');
  };
  const handleNext = () => {
    navigate('/inventories/view');
  };

  const showForm = () => {
    setShowCreateForm(true);
  };

  const onClose = () => {
    setIsSideBarOpen(false);
  };

   const title = !showCreateForm && variations.length >= 1 ? 'List Of Your Variations' : 'Add a Variation';

  return (
    <div>
      <div className="flex items-center justify-between mt-8">
        <div className="flex items-center gap-4">
          <div className="py-2">
            <a href="/inventories">
              <svg
                className="w-[24px] h-[24px]"
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8.5 1L1.5 8L8.5 15" stroke="#33363F" strokeWidth="2" />
              </svg>
            </a>
          </div>
          <h1 className="text-[18px] md:text-[20px] font-medium lg:font-bold">Add New Inventory</h1>
        </div>
        <button
          style={{ fontWeight: 600 }}
          className=" hidden md:block px-[34px] py-4 bg-white cursor-pointer border border-[#044E97] text-[#044E97] text-[16px] rounded-md "
          onClick={() => {
            setIsSideBarOpen(!isSideBarOpen);
          }}
        >
          Input variations
        </button>
      </div>
      <div className="mt-6">
        <h1 className="text-[14px] md:text-[18px] lg:text-[24px] font-normal">
          Create New Inventories and their Variations
        </h1>
      </div>
      <InventoryForm
        handleCreateInventory={handleCreateInventory}
        inventory={inventories}
        variations={variationList}
        setVariations={setVariationList}
        setInventories={setInventories}
        setIsSideBarOpen={setIsSideBarOpen}
        isLoading={isLoading}
        error={error}
        errorMessage={errorMessage}
        variationList={variations}
      />
      {variations.length !== 0 && !showCreateForm ? (
        <SidebarDrawer title={title} show={isSideBarOpen} position="left" onClose={onClose}>
          <VariationList closeForm={showForm} data={variations} />
        </SidebarDrawer>
      ) : (
        <SidebarDrawer title={title} show={isSideBarOpen} position="left" onClose={onClose}>
          <VariationForm closeForm={onClose} close={setIsSideBarOpen} />
        </SidebarDrawer>
      )}
    </div>    
  );
};

export { InventoryPage };
